import React from 'react';
import CounterControl from './CounterControl';

function RadioOption({ label, selected, onClick }) {
    return (
        <div className="flex items-center">
            <div
                className="w-6 h-6 rounded-full border border-gray-300 mr-2 flex items-center justify-center cursor-pointer"
                onClick={onClick}
            >
                {selected && (
                    <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
                )}
            </div>
            <span className="text-gray-600">{label}</span>
        </div>
    );
}

export default function ParticipantSelector({ name, field, setFieldValue }) {
    const updateValue = v => setFieldValue(name, { ...field.value, ...v });
    const incrementAdults = () =>
        updateValue({ adults: Math.min(field.value.adults + 1, 20) });
    const decrementAdults = () =>
        updateValue({ adults: Math.max(field.value.adults - 1, 1) });
    const incrementChildren = () =>
        updateValue({ children: Math.min(field.value.children + 1, 20) });
    const decrementChildren = () =>
        updateValue({ children: Math.max(field.value.children - 1, 1) });

    const toggleExtra = key => {
        updateValue({
            extras: {
                ...field.value.extras,
                [key]: !field.value.extras[key],
            },
        });
    };

    return (
        <div className="absolute mt-2 w-full md:w-96 right-0 md:right-7 bg-white rounded-lg shadow-xl z-10 p-6 -translate-x-1/2 translate-y-[64px] top-0 transform">
            <h2 className="text-xl text-gray-700 mb-4 font-medium">
                Reiseteilnehmer
            </h2>
            <hr className="mb-6 border-gray-200" />

            {/* Adults */}
            <div className="flex justify-between items-center mb-6">
                <span className="text-xl text-gray-600">Erwachsene</span>
                <CounterControl
                    value={field.value?.adults || 0}
                    onIncrement={incrementAdults}
                    onDecrement={decrementAdults}
                />
            </div>

            {/* Children */}
            <div className="flex justify-between items-center mb-6">
                <span className="text-xl text-gray-600">Kinder</span>
                <CounterControl
                    value={field.value?.children || 0}
                    onIncrement={incrementChildren}
                    onDecrement={decrementChildren}
                />
            </div>

            {/* Extras */}
            <div className="flex justify-between text-base flex-wrap gap-6">
                <RadioOption
                    label="Hund"
                    selected={field.value.extras.dog}
                    onClick={() => toggleExtra('dog')}
                />

                <RadioOption
                    label="Barrierearm"
                    selected={field.value.extras.barrier}
                    onClick={() => toggleExtra('barrier')}
                />

                <RadioOption
                    label="Babybett"
                    selected={field.value.extras.babyBed}
                    onClick={() => toggleExtra('babyBed')}
                />
            </div>
        </div>
    );
}
